import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import backgroundImage from '../../assets/images/homepage-bg.jpg';
import './HomePage.css';

const HomePage = () => {
  const { user, devState, profile } = useAuth();
  const navigate = useNavigate();

  // ✅ Real user redirect logic based on auth metadata + user table
  useEffect(() => {
    const setupPages = ['/', '/welcome', '/accountsetup'];

    console.log('🔍 user.isSetupComplete:', user?.isSetupComplete);
    console.log('🔍 profile.accountSetupComplete:', profile?.accountSetupComplete);
    console.log('🔍 current pathname:', window.location.pathname);

    if (!devState && user && setupPages.includes(window.location.pathname)) {
      if (!profile?.accountSetupComplete) {
        console.log('⚠️ Redirecting to /accountsetup');
        navigate('/accountsetup', { replace: true });
      } else {
        console.log('✅ Redirecting to /dashboard/testreports');
        navigate('/dashboard/testreports', { replace: true });
      }
    }
  }, [user, profile, devState, navigate]);

  // ✅ Dev user redirect logic for local testing
  useEffect(() => {
    if (!devState) return;

    if (devState === 'user') {
      navigate('/dashboard/testreports', { replace: true });
    } else if (devState === 'newUser') {
      navigate('/accountsetup', { replace: true });
    }
  }, [devState, navigate]);

  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '690px',
  };

  return (
    <>
      <img src="/rexi-logo.png" className="rexi-logo-home" />
      <div className="home-page" style={backgroundStyle}>
        <div className="hero-section">
          <h1>Comverex.ai</h1>
          <p className="hero-centered">The Compliance Verification Exchange<br /></p>
          <p className="hero-subtitle">
            Trust in product compliance depends on trust in the supply chain.
            <br></br>
            Comverex leverages AI in chain of custody verification.<br /><br />
          </p>
          <div className="cta-buttons">
            {user ? (
              <Link to="/dashboard" className="cta-button primary">
                Go to Dashboard
              </Link>
            ) : (
              <>
<br></br>
<br></br>
<br></br>
{/*}
                <Link to="/register" className="cta-button primary">
                  Get Started
                </Link>
                <Link to="/login" className="cta-button secondary">
                  Log In
                </Link>
*/}
                </>
            )}
          </div>
        </div>
        <div className="features-section">
          <div className="feature-card">
            <p>GS1 standards for identifying products, supply chain locations, and product movement</p>
          </div>
          <div className="feature-card">
            <p>Trusted product compliance verification for both brick and mortar and ecommerce retailers</p>
          </div>
          <div className="feature-card">
            <p>Brand protection confidence with chain of custody from the factory to an ecommerce listing</p>
          </div>
        </div>
        <div className="feature-card-comment">
          <p>AI agent Rexi
            <img
              src="/rexi-logo.png"
              alt="Rexi"
              style={{
                height: '1.7em',
                verticalAlign: 'middle',
                margin: '0 0.04em',
              }}
            />
            helps validate supply chain connections.
            <br></br>She analyzes exchange data and documentation to verify connection claims.
          </p>
        </div>
        <div className="whats-included">
          <p>
            <p style={{ textAlign: 'center' }}><b>ESTABLISHING PRODUCT COMPLIANCE TRUST</b><br></br></p>
            <img src="/rexi-logo.png" alt="Rexi" style={{ height: '2em', verticalAlign: 'middle', transform: 'translateY(-0.1em) translatex(-0.3em)', margin: '0 0.04em' }} />
            <b>The Invitation Model</b><br></br>
            Supply chain connections begin with supply chain members inviting their immediate upstream and downstream
            business partners to the exchange.  Members can be brands, factories, distributors, wholesalers, retailers, and
            ecommerce platform sellers.<br /><br />
            <img src="/rexi-logo.png" alt="Rexi" style={{ height: '2em', verticalAlign: 'middle', transform: 'translateY(-0.1em) translatex(-0.3em)', margin: '0 0.04em' }} />
            <b>Product Compliance Data</b><br></br>
            Product compliance data is provided by the brand owner in the exchange. While any downstream member can confirm
            compliance data exists, detailed compliance data is only shared with members approved by the brand.<br /><br />
            <img src="/rexi-logo.png" alt="Rexi" style={{ height: '2em', verticalAlign: 'middle', transform: 'translateY(-0.1em) translatex(-0.3em)', margin: '0 0.04em' }} />
            <b>Exchange Data Analysis</b><br></br>
            Rexi analyzes exchange data on continual basis, strengthening trust levels based upon the volume of data associated
            with a member and whether or not a full chain of custody exists for a given product.<br /><br />
            <img src="/rexi-logo.png" alt="Rexi" style={{ height: '2em', verticalAlign: 'middle', transform: 'translateY(-0.1em) translatex(-0.3em)', margin: '0 0.04em' }} />
            <b>Compliance Report Analysis</b><br></br>
            Lab testing reports, in-factory product inspection reports, and factory audit reports can be uploaded by
            the service provider at the direction of a member. Rexi analyzes report content to establish data matches in the
            exhange to increase trust levels for corresponding members and products.<br /><br />
            <img src="/rexi-logo.png" alt="Rexi" style={{ height: '2em', verticalAlign: 'middle', transform: 'translateY(-0.1em) translatex(-0.3em)', margin: '0 0.04em' }} />
            <b>Ecommerce Platform Listing Impact</b><br></br>
            Ecommerce platforms are able to utilize chain of custody tracing to compliance data along with seller and product
            trust levels to determine impact on listings and seller rankings.
          </p>
        </div>
        <div className="sign-up">
          <p>
            <div className="cta-buttons">
              {user ? (
                <Link to="/dashboard" className="cta-button primary" style={{ paddingTop: '6px' }}>
                  Go to Dashboard
                </Link>
              ) : (
                <>
{/*}
                  <Link to="/register" className="cta-button primary" style={{ paddingTop: '6px' }}>
                    Get Started
                  </Link>
*/}
                </>
              )}
            </div>
          </p>
        </div>
        <div className="footer-area">
          <div className="footer-area-left">
            <b>Comverex, LLC</b><br />
            236 Raceway Drive<br />
            Suite 15<br />
            Mooresville, NC 28117<br />
            info@comverex.com
          </div>
          <div className="footer-area-center">
            <p style={{ fontSize: '1.5em' }}>
              <a href="https://www.comverex.com/terms_and_conditions.php" target="_blank" rel="noopener noreferrer"
                style={{ color: 'white', textDecoration: 'underline' }}>Terms and Conditions</a>
              <br />
              <a href="https://www.comverex.com/privacy_policy.php" target="_blank" rel="noopener noreferrer"
                style={{ color: 'white', textDecoration: 'underline' }}>Privacy Policy</a>
            </p>
            <br /><br />
            Copyright © 2026 - Comverex, LLC - All Rights Reserved
          </div>
          <div className="footer-area-right">
            <b>CPSC eFiling Links</b><br />
            <a href="//www.cpsc.gov/s3fs-public/eFiling_Quick_Start_Guide.pdf?VersionId=x8fExicz._wNT0yxMq5RWNs2Sk.aJeRT" target="_blank" rel="noopener noreferrer"
              style={{ color: 'white', textDecoration: 'underline' }}>CPSC Quick Start Guide</a><br />
            <a href="//www.cpsc.gov/eFiling-Document-Library" target="_blank" rel="noopener noreferrer"
              style={{ color: 'white', textDecoration: 'underline' }}>CPSC Document Library</a><br />
            <a href="//www.cpsc.gov/Business--Manufacturing/Regulatory-Robot/Safer-Products-Start-Here" target="_blank" rel="noopener noreferrer"
              style={{ color: 'white', textDecoration: 'underline' }}>CPSC Regulatory Robot</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
